import { useEffect } from 'react'

import { TribeEmitterEvent } from '../../lib/index.js'

export const useBMListener = (
  event: TribeEmitterEvent,
  callback: (...args: unknown[]) => unknown,
) => {
  useEffect(() => {
    const setListener = () => {
      window.BM.on(event, callback)
    }

    if (window.BM?._loaded) {
      setListener()
    } else {
      window.BM.on(TribeEmitterEvent.READY, setListener)
    }

    return () => {
      window.BM.off(event, callback)
      window.BM.off(TribeEmitterEvent.READY, setListener)
    }
  }, [event, callback])
}
